var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoModelShow)?_c('div',{staticClass:"lay"},[_c('div',{staticClass:"model",style:(_vm.modelStyle)},[_c('div',{staticClass:"close rotate img-bg",style:(_vm.closeStyle),on:{"click":_vm.close}}),_c('video',{staticClass:"video-box",attrs:{"controls":"","autoplay":"","src":_vm.videoLink}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }